
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'sgt-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard-component.less']
})
export class DashboardComponent implements OnInit {
    @ViewChild('dashboardContainer', {static: true}) dashboardContainer: ElementRef;

    constructor(private router: Router) { }

    ngOnInit() {
        this.addClassByRoute();
        this.subscribeRouterNaviagetionEnd();
    }

    private scrollToTop() {
        jQuery(this.dashboardContainer.nativeElement).scrollTop(0);
    }

    /** Registra nos eventos de NavigationEnd do Router (Quando finaliza a navegação da rota) */
    private subscribeRouterNaviagetionEnd() {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd)
            )
            .subscribe((event) => {
                this.addClassByRoute();
                this.scrollToTop();
            });
    }

    /** Adiciona uma classe CSS ao dashboard conforme a rota atual do dashboard */
    private addClassByRoute() {
        // Minha Região
        if (this.router.url === '/dashboard/minha-regiao') {
            jQuery(this.dashboardContainer.nativeElement).addClass('minha-regiao');
        } else {
            jQuery(this.dashboardContainer.nativeElement).removeClass('minha-regiao');
        }
    }
}
